import { Box, Text } from '@fuegokit/react';
import styled from 'styled-components';

import { ExternalLinks } from '../components/reusable/ExternalLinks';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export function Header() {
  return (
    <Box
      display="flex"
      paddingLeft={2}
      marginBottom={3}
      justifyContent="space-between"
    >
      <Box>
        <LogoContainer className="header">
          <img src="/images/toggl-on.png" width="32px"></img>
          <Text
            sx={{
              fontSize: 7,
              color: 'text.default',
              fontWeight: 'fontWeights.medium',
            }}
          >
            Toggl
          </Text>
        </LogoContainer>
      </Box>
      <Box display="flex" sx={{ gap: 2 }}>
        <ExternalLinks mainPage={true} />
      </Box>
    </Box>
  );
}
